export const UAE_COUNTRY_CODE = '971';
export const EMAIL_VALIDATE_REGEX =
  /^(?!.*\.\.)([\dA-Za-z]+([!#$%&'*+/=?^_`{|}~-]*(\.?))*)*[\dA-Za-z]+@([\dA-Za-z]+(-)?)+(\.[A-Za-z]+)+$/;
export const EMIRATES_ID_VALIDATE_REGEX =
  /^784[-]*(19|20)\d{2}[-]*\d{7}[-]*\d$/;
export const UAE_MOBILE_NUMBER_WITHOUT_COUNTRY_CODE_VALIDATE_REGEX = /^5\d{8}$/;

export const UAE_MOBILE_NUMBER_WITHOUT_W_COUNTRY_CODE = /^\d{7,14}$/;
